import IconComponent from "components/common/Icon";
import NavigationTabs from "components/common/NavigationTabs";
import { inject, observer } from "mobx-react";
import { Icon } from "model/Icon";
import { horizonUrl } from "model/Navigation";
import React, { FunctionComponent, useEffect, useState } from "react";
import NavigationStore from "stores/NavigationStore";
import { useMsal, useAccount } from "@azure/msal-react";
import Loader from "../Loader";
import LoaderStore from "stores/LoaderStore";
import AuthenticationStore from "stores/AuthenticationStore";
import {
  Container,
  Content,
  Footer,
  FooterBottom,
  FooterBottomContent,
  FooterBottomLink,
  FooterBottomText,
  FooterTop,
  Header,
  HeaderActions,
  HeaderBackground,
  HeaderBackgroundBig,
  HeaderBackgroundSmall,
  Logo,
  LogoContainer,
  Navigation,
  NavigationItem,
  noClaimsCardStyling,
  PageTitle,
  PageTop,
  UserButton,
  UserName,
} from "./styles";
import Card from "../Card";
import { Modal } from "../Modal";
import { useHistory } from "react-router";
import { $blue1, $blue2, $textDark, Button } from "styles/common";
import { css } from "styled-components";

interface Props {
  loaderStore: LoaderStore;
  authenticationStore: AuthenticationStore;
  navigationStore: NavigationStore;
  loading: boolean;
}

const Page: FunctionComponent<Props> = ({
  loaderStore,
  authenticationStore,
  navigationStore,
  loading,
  children,
}) => {
  const history = useHistory();

  // const [activeNavItem, setActiveNavItem] = useState(3);
  const activeNavItem = 3;

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [name, setName] = useState("");

  useEffect(() => {
    navigationStore.currentRoute &&
      history.push(navigationStore.currentRoute.route);
  }, [history, navigationStore.currentRoute]);

  useEffect(() => {
    if (account && account.name) {
      setName(account.name);
    }
  }, [account]);

  const handleClaimsDataReload = () => {
    authenticationStore.getUserPermissionsInfo();
  };

  return (
    <Container className="page">
      <PageTop>
        <HeaderBackground>
          <HeaderBackgroundBig>
            <HeaderBackgroundSmall>
              <img src="/static/media/header-bg.867497c3.svg" alt="" />
            </HeaderBackgroundSmall>
          </HeaderBackgroundBig>
        </HeaderBackground>

        <Header>
          <LogoContainer href={horizonUrl}>
            <Logo
              src="data:image/png;base64,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"
              alt="Customer portal logo"
            />
          </LogoContainer>

          <Navigation>
            {navigationStore.horizonNavigation &&
              navigationStore.horizonNavigation.map((item, index) => (
                <NavigationItem
                  key={index}
                  active={index === activeNavItem}
                  onClick={() => {
                    item.route !== "" &&
                      window.open(`${horizonUrl}${item.route}`, "_blank");
                  }}
                >
                  {item.name}
                </NavigationItem>
              ))}
          </Navigation>

          <HeaderActions>
            {authenticationStore.userPermissionsInfo &&
              authenticationStore.userPermissionsInfo.options.hasBacklogUrl && (
                <Button
                  textColor={$textDark}
                  color={$blue1}
                  hoverColor={$blue2}
                  onClick={() => {
                    authenticationStore.userPermissionsInfo &&
                      authenticationStore.userPermissionsInfo.options
                        .developmentBacklogUrl &&
                      window.open(
                        authenticationStore.userPermissionsInfo.options
                          .developmentBacklogUrl,
                        "_blank"
                      );
                  }}
                  extraStyling={css`
                    margin-right: 1rem;
                  `}
                >
                  Development backlog
                </Button>
              )}

            {authenticationStore.userPermissionsInfo &&
              authenticationStore.userPermissionsInfo.options
                .allowTicketManagement && (
                <Button
                  textColor={$textDark}
                  color={$blue1}
                  hoverColor={$blue2}
                  onClick={() => {
                    window.open(
                      "https://horizon.cegeka.com/create-ticket",
                      "_blank"
                    );
                  }}
                  extraStyling={css`
                    margin-right: 1.5rem;
                  `}
                >
                  Create ticket
                </Button>
              )}

            <UserButton>
              <UserName>{name}</UserName>
              <IconComponent name={Icon.user} height="1rem" color="#fff" />
              {/* {renderArrowIcon} */}
            </UserButton>

            {/* <CartButton href="https://horizon.cegeka.com/service-portfolio-management/my-orders">
            <IconComponent
              name={Icon.cart}
              height="1rem"
              color="rgb(249, 251, 252)"
            />
          </CartButton>
          
          <NotificationsButton>
            <IconComponent name={Icon.bell} height="1rem" color="#fff" />
            {renderArrowIcon}
          </NotificationsButton> */}
          </HeaderActions>
        </Header>

        <Content>
          <PageTitle>Integration</PageTitle>

          {authenticationStore.userPermissionsInfo ? (
            <>
              {loaderStore.loading && <Loader />}

              <NavigationTabs navigationStore={navigationStore} />

              {children}
            </>
          ) : loading ? (
            <Loader />
          ) : (
            <Card extraStyling={noClaimsCardStyling}>
              <Modal
                customText="Failed to load user claims"
                customButtonText="Retry"
                action={handleClaimsDataReload}
              />
            </Card>
          )}
        </Content>
      </PageTop>

      <Footer>
        <FooterTop>
          {/* <FooterContact>
            <ContactImg
              alt="Avatar"
              src="/static/media/default-contact.4837916d.svg"
            />
            <Contact>
              <ContactTitle>Your contact</ContactTitle>
              <ContactInfo>
                <ContactInfoLeft>
                  <ContactName>Naam Achternaam</ContactName>
                  <ContactFunction>Functie titel</ContactFunction>
                </ContactInfoLeft>
                <ContactEmail>
                  <EmailIcon>
                    <svg
                      viewBox="0 0 1024 1024"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                    >
                      <path
                        fill="currentColor"
                        d="M1023.992 242.534c0-74.375-60.369-134.743-134.724-134.743 0 0-754.539 0-754.539 0-74.354 0-134.724 60.369-134.724 134.743 0 0 0 538.932 0 538.932 0 74.375 60.369 134.743 134.724 134.743h754.539c74.354 0 134.724-60.369 134.724-134.743v-538.932zM970.111 242.534v538.932c0 44.624-36.237 80.842-80.842 80.842 0 0-754.539 0-754.539 0-44.605 0-80.842-36.218-80.842-80.842v-538.932c0-44.624 36.237-80.842 80.842-80.842h754.539c44.605 0 80.842 36.218 80.842 80.842z"
                      ></path>
                      <path
                        fill="currentColor"
                        d="M512 533.504l470.096-313.403c12.388-8.245 29.124-4.892 37.369 7.478 8.266 12.369 4.911 29.124-7.457 37.369l-485.052 323.368c-9.054 6.043-20.858 6.043-29.912 0l-485.052-323.368c-12.369-8.245-15.723-25.001-7.457-37.369 8.245-12.369 24.981-15.723 37.369-7.478l470.096 313.403z"
                      ></path>
                    </svg>
                  </EmailIcon>
                  <Email href="mailto:david.vanhoven@cegeka.com">
                    naam.achternaam@cegeka.com
                  </Email>
                </ContactEmail>
              </ContactInfo>
            </Contact>
          </FooterContact> */}
        </FooterTop>
        <FooterBottom>
          <FooterBottomContent>
            <FooterBottomText seperator>
              ©2022 Cegeka. All rights reserved
            </FooterBottomText>
            <FooterBottomText seperator>version 1.0.0</FooterBottomText>
            <FooterBottomLink
              seperator
              target="_blank"
              rel="noopener noreferrer"
              href="https://horizon.cegeka.com/terms-of-use"
            >
              Terms of use
            </FooterBottomLink>
            <FooterBottomLink href="https://horizon.cegeka.com/policy/opt-out">
              Decline terms of use
            </FooterBottomLink>
          </FooterBottomContent>
        </FooterBottom>
      </Footer>
    </Container>
  );
};

export default inject(
  "loaderStore",
  "authenticationStore",
  "navigationStore"
)(
  observer(
    Page as FunctionComponent<
      Omit<Props, "loaderStore" | "authenticationStore" | "navigationStore">
    >
  )
);
